<template>
  <div class="mb-3">
    <v-card
      dark
      class="elevation-5"
      style="width: 250px"
      v-if="permission.main_menu.manager_manage"
    >
      <v-list class="py-0" style="background-color: #000">
        <v-list-tile>
          <v-list-tile-title
            style="text-align: center; font-size: 20px; color: white"
            >Manager Management</v-list-tile-title
          >
        </v-list-tile>
      </v-list>
      <v-list class="py-0" style="overflow: hidden">
        <v-list dark class="py-0" style="background-color: #424242">
          <v-list-tile
            v-for="item in singleSidebar"
            :key="item.title"
            :to="item.link"
          >
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content class="white--text">
              {{ item.title }}
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-list-group
          v-for="item in items"
          v-model="item.active"
          :key="item.title"
          :prepend-icon="item.action"
          no-action
        >
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <div>
                {{ item.title }}
                <span
                  v-if="countNumber > 0 && item.title == 'Bank.'"
                  class="circle"
                  >{{ countNumber }}</span
                >
                <span
                  v-if="item.title == 'Money' && fetchCountRequest > 0"
                  class="circle"
                  >{{ fetchCountRequest }}</span
                >
              </div>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            v-for="subItem in item.items"
            :key="subItem.title"
            :to="subItem.url"
          >
            <v-list-tile-content>
              <div>
                {{ subItem.title }}
                <span
                  class="circle"
                  v-if="countNumber > 0 && subItem.title == 'Bank Approve'"
                >
                  {{ countNumber }}
                </span>
              </div>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      singleSidebar: [
        {
          icon: "group",
          title: "Manager List",
          link: "/weserve_admin_login/-/manager-manage",
        },
      ],
      items: [
        {
          action: "emoji_symbols",
          title: "Commission",
          items: [
            {
              title: "Area",
              url: "/weserve_admin_login/-/CommissionArea",
            },
            {
              title: "Withdraw",
              url: "/weserve_admin_login/-/Withdraw",
            },
          ],
        },
        {
          action: "account_balance",
          title: "Bank.",
          items: [
            {
              title: "Bank List",
              url: "/weserve_admin_login/-/BankList",
            },
            {
              title: "Bank Approve",
              url: "/weserve_admin_login/-/Bankapprove",
            },
          ],
        },
        {
          action: "money",
          title: "Money",
          items: [
            {
              title: "Request cash",
              url: "/weserve_admin_login/:province/money",
            },
          ],
        },
      ],
    };
  },
  computed: {
    ...mapState({
      permission: (state) => state.permission,
      countNumber: (state) => state.banklist.getCountApprove,
      fetchCountRequest: (state) => state.cashRequest.fetchCountRequest,
    }),
  },
  methods: {},
};
</script>
<style scoped>
.circle {
  height: 25px;
  width: 25px;
  background-color: red;
  border-radius: 50%;
  display: inline-block;
  text-align: center;
}
</style>
